/*
 * @Author: Dom
 * @Date: 2022-05-18 18:14:45
 * @LastEditTime: 2022-07-03 00:32:00
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\component\enterprise\locales\zh-CN.ts
 */
export default {
    'page.personal.center.compontent.enterprise.message' : '企业信息',
    'page.personal.center.compontent.enterprise.enterpriseName' : '企业名称',
    'page.personal.center.compontent.enterprise.representative' : '法定代表人姓名',
    'page.personal.center.compontent.enterprise.creditCode' : '统一社会信用代码',
    'page.personal.center.compontent.enterprise.validity' : '统一社会信用证有效期',
    'page.personal.center.compontent.enterprise.name' : '联系人姓名',
    'page.personal.center.compontent.enterprise.email':'邮箱',
    'page.personal.center.compontent.enterprise.phone':'联系电话',
    'page.personal.center.compontent.enterprise.address':'联系地址',
    'page.personal.center.compontent.enterprise.addressMod':'详细地址',
    'page.personal.center.compontent.enterprise.select':'请选择开户行所在省市',
    'page.personal.center.compontent.enterprise.businessLicense':'上传公司营业执照扫描件',
    'page.personal.center.compontent.enterprise.size':'文件大小不超过6M',
    'page.personal.center.compontent.enterprise.support':'文件格式支持',
    'page.personal.center.compontent.enterprise.businessLicenseMod':'请上传清晰可见的营业执照副本',
    'page.personal.center.compontent.enterprise.submit':'提交',
    'page.personal.center.compontent.enterprise.reset':'重置',
}
